// extracted by mini-css-extract-plugin
module.exports = {"searchWrap":"viewWorkerUnits_searchWrap__1ybhh","searchBar":"viewWorkerUnits_searchBar__3OlK3","addNewBtn":"viewWorkerUnits_addNewBtn__16sdf"};